export enum ReportType {
    SziluettDiagram = 1,
    SziluettDetails = 2,
    PanoramaAura = 3,
    MilioTeamDysfunction = 4,
    MilioStressMap = 5,
    PositionProfile = 6
}